import React from "react";
import logo from "../../assets/icon/hayd_icon.avif";
import BackArrow from "../../assets/svg/backArrow";
import useAuth from "../../hooks/useAuth";

const Header = ({ onBackClick }) => {
  const { user } = useAuth();
  return (
    <div className="bg-white overflow-hidden">
      <div className="hayd-header p-4 flex items-center justify-center relative pb-3">
        <div
          className="hayd-header-back-logo absolute left-4 cursor-pointer"
          onClick={onBackClick}
        >
          <BackArrow />
        </div>
        <img src={logo} alt="logo" className="w-[100px]" />
      </div>
      <div className="sub-header-banner bg-black px-4 py-2">
        {user ? (
          <p className="text-center text-white text-[14px] general-sans-medium capitalize">
            👋 Hello,{" "}
            {user?.first_name === "HAYD_USER"
              ? "User"
              : user?.first_name + " " + user?.last_name}
          </p>
        ) : (
          <p className="text-center text-white text-[14px] general-sans-medium">
            LOGIN FOR EXCITING OFFERS
          </p>
        )}
      </div>
    </div>
  );
};

export default Header;
